import { GDMSProcessData } from './models/GDMSProcessData';
import { AnalysisStatus } from '../../../models/AnalysisStatus';
import { GDMSStatus } from './models/GDMSStatus';

export class GDMSUtils {
    public static isAnalysisFrozenByGDMS(gdmsProcessData: GDMSProcessData | null | undefined, analysisStatus: AnalysisStatus | null | undefined) {
        if (!analysisStatus) {
            return false;
        }
        return (
            gdmsProcessData &&
            (gdmsProcessData.status === GDMSStatus.IN_WORKFLOW || (gdmsProcessData.status === GDMSStatus.VALID && analysisStatus === AnalysisStatus.DRAFT))
        );
    }
}
